import React from 'react';
import * as _ from 'lodash';

import InOutDashboardContext from './InOutDashboardContext';
import InOutDashboardApi from './InOutDashboardApi';
import dialogLoader from '../../utilities/dialogLoader';
import InOutDashboardService from './InOutDashboardService';
import FieldSettingsApi from '../fieldSettings/FieldSettingsApi';
import FieldSettingsService from '../fieldSettings/FieldSettingsService';
import InOutHistoryUserUnregisteredApi from '../inOutHistoryUserUnregistered/InOutHistoryUserUnregisteredApi';
import ClosedBillingMonthSelectDialog from '../../components/modals/ClosedBiilingMonthSelectDialog';

import LocalStorageService from '../utilities/LocalStorageService';
import SessionStorageService from '../utilities/SessionStorageService';
import { isPartnerCompanyRoleId } from '../../utilities/roleUtility';
import { isNullOrEmpty } from '../../utilities/stringUtil';
import EventManager, { EventType } from '../../utilities/EventManager';
import { isLoginUserPrimaryCompany } from '../../utilities/roleUtility';

/**
 * ダッシュボードのstate管理用コンポーネント
 * */
export default class InOutDashboardStore extends React.Component {
  state = {
    isLoaded: true, // API等でローディング中フラグ
    isOpened: false, // CCUSの送信履歴の失敗ダイアログ
    isShowNotExistFieldIdDialog: false, // 現場IDの存在チェックフラグ
    showMonthlyRecordTableFlag: false, // 月次実績テーブル表示フラグ
    field: Object.create(null), // 現場詳細情報
    unidentifiedTotal: 0, // 不明な入退場データ
    unapprovedTotal: 0, // CCUS送信未承認データ
    inOutRecord: Object.create(null), // 入退場者数情報
    faceImageHistories: Object.create(null), // 顔画像登録数・入退場者数情報
    newsList: [], // お知らせ情報
    searchNews: {
      total: 0,
      offset: 0,
      companyId: null,
    },
    failDialog: {
      message: '',
      title: '',
    },
    selectedTransmissionHistoryId: null,
    errorDialogStatus: false, // エラーダイアログ表示用ステータス
    ccusSecededWarning: false,
    jvFlag: false,
    accumurationErrorFlag: false, // 蓄積期間外エラー有無 
  };

  /**
   * 現場情報が存在しないエラーダイアログを閉じる
   * */
  closeNotExistFieldIdDialog = () => {
    let state = { ...this.state };
    state.isShowNotExistFieldIdDialog = false;
    this.setState(state);
  };

  childSetDialog = (show, message) => {
    const state = _.cloneDeep(this.state);
    state.errorDialogStatus = show;
    state.failDialog.message = message;
    this.setState(state);
  };

  /**
   * CCUS送信結果のエラー情報を初期化し、ダイアログを閉じる
   * */
  closeDialog = () => {
    let state = { ...this.state };
    state.isOpened = !state.isOpened;
    state.selectedTransmissionHistoryId = null;
    this.setState(state);
  };

  /**
   * エラーダイアログのステータスを閉じるに設定する
   * */
  closeErrorDialog = () => {
    let state = { ...this.state };
    state.errorDialogStatus = false;
    this.setState(state);
  };

  selectTransmissionHistory = item => {
    this.setState({
      selectedTransmissionHistoryId: item.id,
      isOpened: true,
    });
  };

  goToUnidentifiedCheckInOutLogs = () => {
    window.location.href =
      '/gatekeeper/0:1/0/0/InOutHistoryUserUnregistered:1/0:0';
  };

  handleClickMonthBillingDialog = () => {
    dialogLoader.show(ClosedBillingMonthSelectDialog, {
      state: {
        field_id: SessionStorageService.getFieldId(),
      },
      callback: {
        back: () => {
          dialogLoader.close();
        },
        submit: () => {
          dialogLoader.close();
        },
      },
      childSetDialog: this.childSetDialog,
    });
  };

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    let state = { ...this.state };

    const fieldId = SessionStorageService.getFieldId();
    if (isNullOrEmpty(fieldId)) {
      state.isShowNotExistFieldIdDialog = true;
      this.setState(state);
      return;
    }

    const response = await InOutDashboardApi.fetchMainJvSecededCcus(fieldId);
    state.ccusSecededWarning = _.get(
      response,
      'data.entities.ccus_seceded_warning'
    );
    state.jvFlag = _.get(response, 'data.entities.sub_jv_exists_flag');

    // 現場情報取得API
    InOutDashboardApi.fetchFieldInfo(fieldId)
      .then(response => {
        if (response.result) {
          state.field = response.data.entities.field;
        } else {
          alert(response.message);
        }
      })
      .catch(error => {
        alert(error);
      })
      .finally(() => {
        FieldSettingsApi.fetchCheckInOutSettings(fieldId)
          .then(response => {
            if (response.result) {
              const settings = FieldSettingsService.parseFetchCheckInOutSettingsResponseData(
                response.data
              );
              SessionStorageService.setSpotFlg(settings.spot_flg);
              SessionStorageService.setUseWorkerEntranceAppFlg(settings.use_worker_entrance_app_flg);
              EventManager.trigger(EventType.LAYOUT_UPDATE, {});
            } else {
              alert(response.message);
            }
          })
          .catch(error => {
            alert(error);
          })
          .finally(() => {
            // 入退場者数取得API
            InOutDashboardApi.fetchEnteredAndExitCount(
              SessionStorageService.getFieldId()
            )
              .then(response => {
                if (response.result) {
                  state.inOutRecord = response.data.entities.check_in_out_logs;
                } else {
                  alert(response.message);
                }
              })
              .catch(error => {
                alert(error);
              })
              .finally(() => {
                // CCUS送信履歴API
                state.searchNews.companyId = SessionStorageService.getCompanyId();
                InOutDashboardApi.fetchCheckInOutLogTransmissionHistories(
                  SessionStorageService.getFieldId(),
                  InOutDashboardService.createSearchCheckInOutLogTransmissionHistories(
                    state.searchNews
                  )
                )
                  .then(response => {
                    if (response.result) {
                      state.searchNews.total = response.data.total;
                      state.newsList =
                        response.data.entities.check_in_out_log_transmission_histories;
                      state.accumurationErrorFlag = _.get(response,'data.accumuration_error_flag');
                    } else {
                      alert(response.message);
                    }
                  })
                  .catch(error => {
                    alert(error);
                  })
                  .finally(() => {
                    if (
                      isPartnerCompanyRoleId(LocalStorageService.getRoleId())
                    ) {
                      state.isLoaded = false;
                      this.setState(state);
                    } else {
                      // 不明な入退場データ一覧取得API
                      InOutHistoryUserUnregisteredApi.fetchUnidentifiedLogs(
                        SessionStorageService.getFieldId(),
                        { prior_ccus_error_flg: 0, data_type: 'count' }
                      )
                        .then(response => {
                          if (response.result) {
                            state.unidentifiedTotal = response.data.total;
                          } else {
                            alert(response.message);
                          }
                        })
                        .catch(error => {
                          alert(error);
                        })
                        .finally(() => {
                          // CCUS送信未承認数取得API
                          InOutDashboardApi.fetchUnapprovedCount(
                            SessionStorageService.getFieldId()
                          )
                            .then(response => {
                              if (response.result) {
                                state.unapprovedTotal =
                                  response.data.entities.check_in_out_logs.unapproved_count;
                              } else {
                                alert(response.message);
                              }
                            })
                            .catch(error => {
                              alert(error);
                            })
                            .finally(() => {
                              if (
                                !isLoginUserPrimaryCompany(
                                  LocalStorageService.getRoleId()
                                )
                              ) {
                                state.isLoaded = false;
                                this.setState(state);
                              } else {
                                // 顔画像登録数、入退場者数を取得API
                                InOutDashboardApi.fetchMonthlyCount(
                                  SessionStorageService.getFieldId()
                                )
                                  .then(response => {
                                    if (response.result) {
                                      state.faceImageHistories =
                                        response.data.entities.face_api_field_worker_image_histories;
                                    } else {
                                      alert(response.data.message);
                                    }
                                  })
                                  .catch(error => {
                                    alert(error);
                                  })
                                  .finally(() => {
                                    state.showMonthlyRecordTableFlag = true;
                                    state.isLoaded = false;
                                    this.setState(state);
                                  });
                              }
                            });
                        });
                    }
                  });
              });
          });
      });
  }

  render() {
    return (
      <InOutDashboardContext.Provider
        value={{
          state: this.state,
          handleClickMonthBillingDialog: this.handleClickMonthBillingDialog,
          childSetDialog: this.childSetDialog,
          closeNotExistFieldIdDialog: this.closeNotExistFieldIdDialog,
          closeDialog: this.closeDialog,
          selectTransmissionHistory: this.selectTransmissionHistory,
          goToUnidentifiedCheckInOutLogs: this.goToUnidentifiedCheckInOutLogs,
          closeErrorDialog: this.closeErrorDialog,
        }}
      >
        {this.props.children}
      </InOutDashboardContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/inOutDashboard/InOutDashboardStore.js